<script setup lang="ts">
import VExpansionPanel from '@/shared/ui/VExpansionPanel.vue';
import { FieldLabel } from '@/shared/ui';
import { FormDatePicker, type HotelSelectItem } from '@/features/application/applicationForm';

const props = defineProps<{
    /** ホテル選択肢 */
    hotelItems: HotelSelectItem[];
    /** バリデーションエラー */
    errors?: {
        hotelId?: string[];
        checkInDate?: string[];
        checkOutDate?: string[];
    };
}>();

const hotelId = defineModel<string>('hotelId', { required: true });
const checkInDate = defineModel<string>('checkInDate', { required: true });
const checkOutDate = defineModel<string>('checkOutDate', { required: true });

// 今日の日付（過去日選択を制限するため）
const today = new Date();

// ホテル選択肢のitem-props設定（管理者向け：日本語固定）
const getItemProps = (item: HotelSelectItem) => {
    if (item.type === 'subheader') {
        return {
            type: 'subheader',
            title: item.japaneseName,
        };
    }
    return {
        title: item.japaneseName,
        value: item.value,
    };
};
</script>

<template>
    <VExpansionPanel title="発送元" :default-open="true">
        <div class="edit-panel-content">
            <div class="edit-panel-row">
                <FieldLabel label="ホテル名" />
                <v-select
                    v-model="hotelId"
                    :items="hotelItems"
                    :item-props="getItemProps"
                    variant="outlined"
                    density="compact"
                    placeholder="選択してください"
                    :error-messages="props.errors?.hotelId"
                    :hide-details="!props.errors?.hotelId"
                />
            </div>

            <FormDatePicker
                v-model="checkInDate"
                label="チェックイン日"
                aria-label="check-in-date"
                :min="today"
                :error-messages="props.errors?.checkInDate"
            />

            <FormDatePicker
                v-model="checkOutDate"
                label="チェックアウト日"
                aria-label="check-out-date"
                :min="today"
                :error-messages="props.errors?.checkOutDate"
            />
        </div>
    </VExpansionPanel>
</template>

<style scoped>
.edit-panel-content {
    padding: 16px;
    background-color: #fafafa;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.edit-panel-row {
    display: flex;
    flex-direction: column;
    gap: 4px;
}
</style>
